module.exports = __webpack_public_path__ + "img/logo.8048a731.svg";